import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const AccountsTeamLayout = () => {
  const navList = useNav();
  let {accountTeamBottomNav, topAccountNav} = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={accountTeamBottomNav} topTabs={topAccountNav} />
      <Outlet />
    </div>
  )
}

export default AccountsTeamLayout;